import { useQuery } from 'react-query';
import { useSelector } from 'react-redux';
import { apiService } from '../../../utils/api';

export const useGetTemplates = () => {
  return useQuery({
    queryKey: 'templates',
    queryFn: async () => {
      const { data } = await apiService.get(
        `/api/v1/instruction-template/dropdown/?pagination=false`
      );
      return data;
    },
    refetchOnWindowFocus: false,
  });
};

export const useGetClassFilterPresets = (enabled: boolean) => {
  return useQuery({
    queryKey: ['class-filter-presets'],
    queryFn: async () => {
      const { data } = await apiService.get(`/api/v1/menu/class-filter-presets/`);
      return data;
    },
    enabled,
    refetchOnWindowFocus: false,
  });
};

export const useGetBuildingObjects = () => {
  const model = useSelector((state) => state.contract.modelId);

  return useQuery({
    queryKey: ['building-objects'],
    queryFn: async () => {
      const { data } = await apiService.get(`/api/v1/building-object/dropdown/`, {
        params: {
          model: model,
          pagination: 'false',
        },
      });
      return data;
    },
    refetchOnWindowFocus: false,
  });
};
